import { useEffect, useState } from "react";
import { MainPageBase } from "../page-bases/MainPageBase";
import { NoItemContent } from "../page-bases/NoItemContent";
import { Box, Stack } from "@mui/material";
import { useParams } from "react-router-dom";

import { TRowItem } from "../../components/Table/TableRow";
import { usePagination } from "../../hooks/usePagination";
import { assetBatchDistributionApi } from "../../services/distribution/asset-distribution";

import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { SimpleLabel } from "../../components/Label/SimpleLabel";
import { updateBatchDistributionCart } from "../../store/reducers/distribution/distributedRecordStore";
import { AssetDistributionQueryParams, IAssetRecord, IPagination, IQueryPerams } from "../../config/types";
import { formatDate } from "../../utils/common";
import DamsTable from "../../components/Table/CollapsibleTable";
import LabelButton from "../../components/Button/LabelButton";
import useAppNavigation from "../../hooks/useAppNavigation";
import appRoutePath from "../../config/path";
import { DistributedAssetsLogsFilter } from "../../common-ui/page-filters/DistributedAssetsLogsFilter";
function OutBoundDistributionDetailPage() {
  const [pageState, setPageState] = useState<string>("main");
  const [dataset, setDataset] = useState<TRowItem[]>([]);
  const { id } = useParams<{ id: string }>();
  const entryDetail = useAppSelector((data) => data.batchDistributionCart);
  const fetchAssetsFromDistribution=(query?: AssetDistributionQueryParams)=> assetBatchDistributionApi.getAssetFromDistribution(
    id ?? "",query
  )
  const {
    pagination,
    paginateToNextPage,
    paginateToPreviousPage,
    paginateToPageNumber,
    updatePaginationInitState,
  } = usePagination<any>(fetchAssetsFromDistribution);
  const dispatch = useAppDispatch();
  const navigate=useAppNavigation()

  const [querySet, setQuerySet] = useState<IQueryPerams>({ is_deleted: false });
  const populateDataSet = (data: IAssetRecord[], pagination?: IPagination) => {
    const formatData = data.map((data) => ({
      ...data,
      date_received: formatDate(data.date_received),
      brand:`${data.brand} (${data.model})`,
      current_location_domain:`${data.current_location_domain} (${data.current_location})`,
      asset_meta_raw: data.asset_meta
        ? data.asset_meta.map(
            (item) => ` ${item.asset_tag}=${item.meta_value} `
          )
        : [],
    }));

    setDataset(formatData);
    updatePaginationInitState(pagination);
  };

  const fetchData = async () => {
    const result = await assetBatchDistributionApi.getAssetFromDistribution(
      id ?? ""
    );
    if (result?.data) {
      populateDataSet(result.data, result.pagination);
    }
    const distributionDetail =
      await assetBatchDistributionApi.getBatchDistribution(id ?? "");
    if (distributionDetail.data) {
      dispatch(updateBatchDistributionCart(distributionDetail.data));
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  function addNewItem() {}

  function clearSearch() {
    setPageState("empty-db");
  }




  if (!entryDetail.id) {
    return null;
  }


  return (
    <MainPageBase
      pageState={"main"}
      title={`Distribution Information`}
      extraComponent={
        <LabelButton
          onPress={() =>{
             navigate({ path: appRoutePath.OUTBOUND_ASSET_DISTRIBUTIONS_PAGE })
          }
           
          }
          label={"Back"}
          direction={"left"}
        />
      }
    >
      <Box
        height={`100%`}
        display={"flex"}
        alignItems={pageState !== "main" ? "center" : ""}
        justifyContent={"center"}
      >
        {pageState !== "main" ? (
          <NoItemContent
            type={pageState}
            title={""}
            subtitle={""}
            addItemBtn={() => addNewItem()}
            clearSearchBtn={() => clearSearch()}
          />
        ) : (
          <Stack width={"100%"}>
            <Stack spacing={1.5} marginBottom={2} direction={"column"}>
              <SimpleLabel title="Departure Details" />
              <Stack direction={"row"} width={"100%"}>
                <SimpleLabel title="Departure domain" fontWeight={400} />
                <SimpleLabel
                  fontWeight={700}
                  title={entryDetail.from_location_domain}
                  width={"100%"}
                />
              </Stack>
              <Stack direction={"row"} width={"100%"}>
                <SimpleLabel
                  title="Departure domain location"
                  fontWeight={400}
                />
                <SimpleLabel
                  fontWeight={700}
                  title={entryDetail.from_location}
                  width={"100%"}
                />
              </Stack>
              <SimpleLabel title="Recipent Details" />
              <Stack direction={"row"} width={"100%"}>
                <SimpleLabel title="Recipent domain" fontWeight={400} />
                <SimpleLabel
                  fontWeight={700}
                  title={entryDetail.to_location_domain}
                  width={"100%"}
                />
              </Stack>
              <Stack direction={"row"} width={"100%"}>
                <SimpleLabel
                  title="Recipent domain distination"
                  fontWeight={400}
                />
                <SimpleLabel
                  fontWeight={700}
                  title={entryDetail.to_location}
                  width={"100%"}
                />
              </Stack>
            </Stack>

          <DistributedAssetsLogsFilter<IAssetRecord[]>
            ftn={fetchAssetsFromDistribution}
            updateDataSet={populateDataSet}
            updateQuerySet={setQuerySet}
            isAssigned={false}
            isDeleted={false}
          />
            <DamsTable
              tableTitle={"Distribution Assets"}
              tableSubtitle={""}
              tableHeaders={columns}
              hiddenKeys={hkeys}
              hiddenLabels={hcolumns}
              data={dataset}
              tableKeys={tkeys}
              hasPagination
              maxRowCells={6}
              paginationState={pagination}
              onNextPage={paginateToNextPage(querySet, populateDataSet)}
              onPreviousPage={paginateToPreviousPage(querySet, populateDataSet)}
              setActivePage={paginateToPageNumber(populateDataSet, querySet)}
            />
          </Stack>
        )}
      </Box>
    </MainPageBase>
  );
}

const tkeys = [
    "brand",
    "serial_number",
    "embossment_number",
    "distribution_status",
    "assigned",
    "date_received"
  ];
  
  const columns = [
    "Brand (Model)",
    "Serial Number",
    "Embossment Number",
    "Distribution Status",
    "Assigned",
    "Date Received"
  ];
  const hkeys = [ "asset_category_name","warranty_in_months","batch_number","current_location_domain", "asset_meta_raw"];
  
  const hcolumns = ["Asset Category","Warranty (months)","Batch Number","Current Location - Domain (Location)", "Additional Information"];
  
export { OutBoundDistributionDetailPage };
